import * as React from 'react';
import { connect } from 'react-redux';
import {
    updatePublicacionEstadoVariacionApi,
    postAprobarPublicacionApi,
    postDesaprobarPublicacionApi
} from '../../../../api/axios'
import { fetchPublicacion, editPublicacion } from '../../../../actions/publicacionesActions';
import { toast } from 'react-toastify';

class Estado extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            estado: this.props.publicacion.estado,
        };
    }
    handleChange = (event) => {
        event.preventDefault();
        let publicacion = { ...this.props.publicacion };
        publicacion[event.target.name] = event.target.value;
        this.props.editPublicacion(publicacion);
    }
    goToPreviousPath = () => {
        const { pathReturn } = this.props.location.state;
        this.props.history.push(`${pathReturn}`);
    }

    setEstado = (event) => {
        event.preventDefault();
        let publicacion = { ...this.props.publicacion };
        publicacion.estado = event.target.name;
        let request = {
            idUser: this.props.userId,
            idPublicacion: publicacion.idPublicacion,
            skuSeller: publicacion.skuSeller,
            stock: publicacion.stock,
            estado: event.target.name
        }
        if ((this.props.userType.isAdminMod || this.props.userType.isCategory) && event.target.name == "activo") {
            const reqAprobar = postAprobarPublicacionApi({ idPublicacion: this.props.publicacion.idPublicacion });
            reqAprobar.then(res => {
                this.props.editPublicacion(publicacion);
                toast.success("Publicación aprobada");
                this.setState({ estado: event.target.name }) 
                
            }).catch(err => {
                (err.response.data.errores)
                    ? err.response.data.errores.forEach(error => toast.error(error))
                    : toast.error("No pudo aprobarse");
            });
        } else {
            if (this.props.userType.isAdminMod || this.props.userType.isCategory) {
                const reqDesaprobar = postDesaprobarPublicacionApi({ IdPublicacion: this.props.publicacion.idPublicacion });

                reqDesaprobar.then(res => {
                    this.props.editPublicacion(publicacion);
                    toast.success("Publicación desaprobada");
                    this.setState({ estado: event.target.name }) 
                    
                }).catch(err => {
                    (err.response.data.errores)
                        ? err.response.data.errores.forEach(error => toast.error(error))
                        : toast.error("No pudo desaprobarse");
                });
            } else {
                console.log("🎗")
                this.props.editPublicacion(publicacion);
                //const req = updatePublicacionEstadoVariacionApi(request);
                //req.then(res => {
                //    this.props.editPublicacion(publicacion);
                //    toast.success("Estado modificado");
                //    this.setState({ estado: event.target.name })
                    
                //}).catch(err => {
                //    // (err.response.data.errores)
                //    //     ? err.response.data.errores.forEach(error => toast.error(error))
                //    //     : toast.error("No pudo editarse");
                //}).finally(() => {
                //    this.setState({ isClicked: false })
                //});
            }
            
        }
        

    }


    render() {
        const { isCategory, isAdminMod } = this.props.userType;

        const switchClassEstado = () => {
            switch (this.props.publicacion.estado) {
                case "activo":
                    return "label-success"
                case "pendiente_activacion":
                    return "label-grey"
                case "pausado":
                    return "label-red"
                case "en_revision":
                    return "label-primary"
                default:
                    return ""
            }
        }

        let motivosDeRevisionOptions = null;
        if (this.props.motivosRevision != null) {
            motivosDeRevisionOptions = this.props.motivosRevision.map((motivo, index) => {
                return <option key={index} value={motivo.codigo}>{motivo.descripcion}</option>
            });
        }

        let btnAprobarModerador = (isCategory || isAdminMod) && 
            <button
                name="activo"
                onClick={this.setEstado}
                className="btn background-rojo-megatone waves-effect waves-light btn-sm m-r-10"
                disabled={this.state.estado == "activo"}
            >
                Aprobar
            </button>;

        let btnPausarModerador = (isCategory || isAdminMod) &&
            <button
                disabled={this.state.estado == "pausado" || this.state.estado == "en_revision"}
                name="en_revision"
                onClick={this.setEstado}
                className="btn background-rojo-megatone waves-effect btn-sm waves-light m-r-10"
            >
                Pausar
            </button>;

        let btnPublicarSeller = (isCategory || isAdminMod) ? "" :
            <button
                className="btn background-rojo-megatone waves-effect waves-light btn-sm m-r-10"
                disabled={
                    this.props.inCreate ||
                    this.state.estado != "pausado"
                }
                name="activo"
                onClick={this.setEstado}
            >
                
                Publicar
            </button>;

        let btnPausarSeller = (isCategory || isAdminMod) ? "" :
            <button
                disabled={this.state.estado == "pausado" || this.props.inCreate}
                onClick={this.setEstado}
                name="pausado"
                hidden={this.state.estado == "en_revision" || this.state.estado == "pendiente_activacion"}
                className="btn background-rojo-megatone waves-effect waves-light btn-sm m-r-10"
            >
                Pausar
            </button>;

        if ((this.state.estado == "pausado" || this.props.inCreate) && (!isCategory && !isAdminMod)) {
            btnPausarSeller = ""
        }

        if ((this.props.inCreate
            || this.state.estado == "pendiente_activacion"
            || this.state.estado == "en_revision"
            || this.state.estado == "activo")
            && (!isCategory && !isAdminMod)) {
            btnPublicarSeller = ""
        }

        if ((this.state.estado === "activo") && (isCategory || isAdminMod)) {
            btnAprobarModerador = ""
        }

        if ((this.state.estado == "pausado" || this.state.estado == "en_revision") && (isCategory || isAdminMod)) {
            btnPausarModerador = ""
        }

        let codigoMotRevision = null;
        if (this.props.motivosRevision != undefined) {
            if (this.props.motivosRevision.at(-1) != undefined) {
                codigoMotRevision = this.props.motivosRevision.at(-1).codigo;
            }
        }

        return (
            <div className="tab-pane p-20 active" name="datos" id="home2" role="tabpanel">
                <div className="row">
                    <div className="col-lg-8 col-md-8 col-sm-8">

                        <div className="form-group">
                            <div className="d-flex">
                                <div className="mr-auto p-2">
                                    <span className={`label p-10 text-uppercase ${switchClassEstado()}`}>{this.state.estado}</span>
                                </div>
                                <div className="p-2 d-none d-lg-block">
                                    {btnPublicarSeller}
                                    {btnPausarSeller}
                                    {btnAprobarModerador}
                                    {btnPausarModerador}
                                </div>
                            </div>
                        </div>

                        <div className="form-group" hidden={this.props.publicacion.estado === "activo"}>
                            <label>Motivo</label>
                            <select
                                className=" form-control col-12"
                                disabled={this.props.publicacion.estado != "en_revision" || (!isCategory && !isAdminMod)}
                                value={this.props.publicacion.idMotivoRevision}
                                onChange={this.handleChange}
                                id="inlineFormCustomSelect"
                                name="idMotivoRevision"
                            >
                                {motivosDeRevisionOptions}
                            </select>
                        </div>

                        <div className="form-group">
                            <label>Operador</label>
                            <input type="text" className="form-control" disabled name="precioLista" />
                        </div>

                        <div className="form-group">
                            <label>Fecha Hora</label>
                            <input
                                type="text"
                                className="form-control"
                                disabled
                                value={this.props.publicacion.fechaUltimaModificacion}
                                name="fecha"
                            />
                        </div>

                        <div
                            className="form-group"
                            hidden={this.props.publicacion.idMotivoRevision != codigoMotRevision || this.props.publicacion.estado === "activo"}
                        >
                            <label htmlFor="exampleFormControlTextarea1">Comentario</label>
                            <textarea
                                name="observacionesRevision"
                                disabled={!isCategory && !isAdminMod}
                                className="form-control"
                                id="exampleFormControlTextarea1"
                                onChange={this.handleChange}
                                rows="3"
                            >
                                {this.props.publicacion.observacionesRevision}
                            </textarea>
                        </div>

                    </div>
                </div>
            </div>
        )
    }
}


const mapStateToProps = state => ({
    userType: state.general.userType,
    publicacion: state.publicaciones.publicacion,
    varciaciones: state.publicaciones.variacionesPublicacion,
    motivosRevision: state.publicaciones.motivosRevision,
    userId: state.general.userId,
});

export default connect(mapStateToProps, { fetchPublicacion, editPublicacion })(Estado);